/* eslint-disable */
import { MenuItem, Select } from "@mui/material";

const CustomReportEquipmentPartSelect = ({name, list, labelName, onChange, ...restProps}) => {
    return (
        <Select
            {...restProps}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            onChange={onChange}
        >
            <MenuItem 
            key="empty"
            value={''}>
                {labelName}
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.id} value={opt.id}>
                {opt.position}-{opt.masterEquipmentPart.name}
            </MenuItem> 
            ))}
        </Select>
    );
};

export default CustomReportEquipmentPartSelect;